// Legal accordions also work without JavaScript through native details/summary.
(() => {
  function initializeLegal(scope = document) {
    scope.querySelectorAll('[data-legal-accordion]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      group.addEventListener('toggle', event => {
        const item = event.target;
        if (item.tagName !== 'DETAILS' || !item.open) return;
        group.querySelectorAll('details[open]').forEach(other => { if (other !== item) other.open = false; });
      }, true);
    });
  }
  function openAnchor() {
    if (!location.hash) return;
    let id; try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    const item = document.getElementById(id);
    if (item?.matches('details.legal-page__item')) item.open = true;
  }
  initializeLegal(); openAnchor();
  addEventListener('hashchange', openAnchor);
  document.addEventListener('shopify:section:load', event => initializeLegal(event.target));
  document.addEventListener('shopify:block:select', event => {
    const item = event.target.closest('details.legal-page__item');
    if (item) item.open = true;
  });
})();
